import { useLogon } from '@core/Utils/hooks'
import React from 'react'
import { useLocation } from 'react-router'

declare global {
  interface Window {
    _qualtrics?: {
      betData?: {
        category: 'sports' | 'racing'
        incentive: 'special' | 'bonus'
        stake: number
        betType: string
        code: string
      }
    }
    QSI?: {
      API: {
        run: () => void
      }
      config: {
        externalReference?: number
      }
    }
  }
}

export const setQualtricsBetData = (
  category: 'sports' | 'racing',
  incentive: 'special' | 'bonus',
  stake = 0,
  betType = '',
  code = ''
) => {
  window._qualtrics = window._qualtrics || {}
  window._qualtrics.betData = {
    category: category,
    incentive,
    stake,
    betType,
    code,
  }
}

export const useQualtricsInterceptor = () => {
  const location = useLocation()
  const { isLoggedIn, accountNumber } = useLogon()
  const [shouldTriggerIntercept, setShouldTriggerIntercept] = React.useState(true)

  // Clear/Set user data on login/logoff
  React.useEffect(() => {
    if (!isLoggedIn) {
      clearQualtricsAccountData()
      clearQualtricsBetData()
    }
  }, [isLoggedIn])

  // Trigger intercept
  // Only trigger intercept when:
  // - Qualtric has loaded
  // - on home page
  // - logged in
  // - intercept data is set
  React.useEffect(() => {
    if (
      !shouldTriggerIntercept ||
      !window.QSI ||
      location.pathname != '/' ||
      !isLoggedIn ||
      !accountNumber ||
      !window._qualtrics?.betData
    ) {
      return
    }
    setTimeout(() => {
      if (window.QSI) {
        window.QSI.config.externalReference = accountNumber
        window.QSI.API.run()
        setShouldTriggerIntercept(false)
      }
    }, 1000)
  }, [location, isLoggedIn, accountNumber, shouldTriggerIntercept])
}

function clearQualtricsAccountData() {
  if (window.QSI) window.QSI.config.externalReference = undefined
}

function clearQualtricsBetData() {
  if (window._qualtrics) {
    window._qualtrics.betData = undefined
  }
}
